module.exports = __webpack_public_path__ + "img/bars.ac446ecf.svg";